export const reducerPlatformModulesName = '@platform/platform-modules';
